import { BreakdownType } from "./recipeImpactChart.types";

/** Breakdown category identifiers used in switch statements and comparisons. */
export const BREAKDOWN_TYPE: Record<"generic" | "product" | "process", BreakdownType> = {
  generic: "generic",
  product: "product",
  process: "process"
};

/** Ordered list of all breakdown categories. */
export const BREAKDOWN_TYPES: BreakdownType[] = [
  BREAKDOWN_TYPE.generic,
  BREAKDOWN_TYPE.product,
  BREAKDOWN_TYPE.process
];

/** Prefix applied to each breakdown item id, keyed by breakdown type. */
export const BREAKDOWN_ID_PREFIX: Record<BreakdownType, string> = {
  generic: "g-",
  product: "p-",
  process: "pr-"
};

/** Object field used to build a stable id per breakdown type. */
export const BREAKDOWN_ID_FIELD: Record<BreakdownType, string> = {
  generic: "ingredientId",
  product: "productId",
  process: "_id"
};

/** Object field used to read the display name per breakdown type. */
export const BREAKDOWN_NAME_FIELD: Record<BreakdownType, string> = {
  generic: "ingredientName",
  product: "productName",
  process: "processName"
};

/** Keys used to read each breakdown collection from a raw impact breakdown object. */
export const BREAKDOWN_KEY: Record<BreakdownType, string> = {
  generic: "genericIngredient",
  product: "calculatedProductSalesUnit",
  process: "processes"
};

/** Stack draw order (bottom → top): processes, then products, then generic ingredients. */
export const BREAKDOWN_SORT_ORDER: Record<BreakdownType, number> = {
  process: 1,
  product: 2,
  generic: 3
};

/** Static text labels used across the chart. */
export const CHART_LABEL = {
  baseline: "Baseline",
  totalImpact: "Total Impact",
  unknown: "Unknown"
} as const;

/** Static, human-readable chart copy. */
export const CHART_TEXT = {
  title: "kgCO2 emissions",
  yAxisName: "kgCO2eq/kg"
} as const;

/** Colors that are specific to the chart presentation. */
export const CHART_COLOR = {
  title: "#71A950",
  totalLabel: "#333",
  transparent: "transparent"
} as const;

/** When the number of breakdown items exceeds this, the legend is split into two rows. */
export const LEGEND_SPLIT_THRESHOLD = 10;

/** Layout measurements (pixels / percentages) for the ECharts option. */
export const CHART_LAYOUT = {
  titlePadding: 20,
  titleFontSize: 16,
  legendItemWidth: 14,
  legendItemHeight: 10,
  legendFontSize: 12,
  legendTopSingle: 40,
  legendTopFirstRow: 40,
  legendTopSecondRow: 70,
  gridTopWithSplitLegend: 130,
  gridTopWithSingleLegend: 90,
  gridLeft: "5%",
  gridRight: "5%",
  gridBottom: 30,
  yAxisNameGap: 40,
  yAxisNameRotate: 90
} as const;
